import { Button, Col, Form, Modal, Row } from 'react-bootstrap'
import * as Yup from 'yup'

type Values = {
  name: string
  newName: string
}

type Props = {
  values: Values
  errors: Partial<Values>
  touched: Partial<Record<keyof Values, boolean>>
  handleChange: React.ChangeEventHandler<HTMLInputElement>
  handleBlur: React.FocusEventHandler<HTMLInputElement>
  handleSubmit: React.SubmitEventHandler<HTMLFormElement>
  fetching: boolean
  title: string
  submitButtonText: string
  onClickCancel: () => void
}

const _SettingCopyForm = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  handleSubmit,
  fetching,
  title,
  submitButtonText,
  onClickCancel
}: Props) => (
  <>
    <Modal.Header>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Form noValidate onSubmit={handleSubmit}>
      <Modal.Body>
        <p>以下の紙面ベースを複製します。よろしいですか？</p>
        <p>コピー元紙面ベース名称：{values.name}</p>
        <Row>
          <Form.Group as={Col}>
            <Form.Label column>コピー後紙面ベース名称</Form.Label>
            <Form.Control
              id='newNameInput'
              name='newName'
              value={values.newName}
              onChange={handleChange}
              onBlur={handleBlur}
              isInvalid={!!(touched.newName && errors.newName)}
            />
            <Form.Control.Feedback type='invalid'>{errors.newName}</Form.Control.Feedback>
          </Form.Group>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onClickCancel}>
          キャンセル
        </Button>
        <Button type='submit' disabled={fetching}>
          {submitButtonText}{' '}
        </Button>
      </Modal.Footer>
    </Form>
  </>
)

export const SettingCopyForm = Object.assign(_SettingCopyForm, {
  schema: Yup.object().shape({
    name: Yup.string().required(),
    newName: Yup.string().required()
  })
})
